
import React, { useState } from "react";
import { Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, MenuItem, Select, SelectChangeEvent, TextField } from "@mui/material";

export const AddRoleDialog = ({ open, handleClose, handleSubmit, permissionsOptions }) => {
    const [roleName, setRoleName] = useState<string>("")
    const [selectedPermissions, setSelectedPermissions] = useState<string[]>([])

    const closeAndClear = () => {
        setSelectedPermissions([])
        setRoleName("")
        handleClose()
    }

    const updateSelectedPermissions = (value) => {
        setSelectedPermissions(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    return (
        <Dialog
            open={open}
            onClose={closeAndClear}
            slotProps={{
                paper: {
                    component: 'form',
                    onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
                        event.preventDefault();
                        setSelectedPermissions([])
                        setRoleName("")
                        handleSubmit(roleName, selectedPermissions);
                    },
                },
            }}
            fullWidth={true}
            maxWidth={"sm"}
        >
            <DialogTitle>Add Role</DialogTitle>
            <DialogContent>
                <FormControl fullWidth margin="normal">
                    <TextField
                        autoFocus
                        required
                        margin="dense"
                        id="roleName"
                        name="roleName"
                        label="Role Name"
                        type="text"
                        fullWidth
                        variant="standard"
                        onChange={(event) => setRoleName(event.target.value)}
                    />
                </FormControl>
                <FormControl fullWidth margin="normal">
                    <Autocomplete
                        id="role-permissions-autocomplete"
                        multiple
                        options={permissionsOptions}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Permissions"
                                name="permissions"
                            />
                        )}
                        value={selectedPermissions}
                        onChange={(_event, newValue) => {
                            updateSelectedPermissions(newValue)
                        }}
                    />
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button onClick={closeAndClear}>Cancel</Button>
                <Button type="submit">Create</Button>
            </DialogActions>
        </Dialog>
    )
}
